import React, { useState } from "react";
import Layout from "components/layouts/Layout";

// Simple icon placeholder for header and images
const ImageIcon = () => (
  <div
    style={{
      width: 40,
      height: 40,
      border: "2px solid #f59e42",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto",
      borderRadius: 6,
    }}
  >
    <svg width="24" height="24" stroke="#f59e42" fill="none" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="8" cy="8" r="2" />
      <path d="M3 21l6-6 4 4 8-8" />
    </svg>
  </div>
);

function PageIndicators({ step }) {
  return (
    <div style={{ textAlign: "center", margin: "1.5rem 0 0.5rem 0" }}>
      {[1, 2, 3].map((n, i) => (
        <span
          key={n}
          style={{
            display: "inline-block",
            width: 24,
            height: 24,
            lineHeight: "24px",
            borderRadius: "50%",
            background: step === i + 1 ? "#2563eb" : "#e5e7eb",
            color: step === i + 1 ? "#fff" : "#222",
            fontWeight: 600,
            margin: "0 4px",
            fontSize: 15,
          }}
        >
          {n}
        </span>
      ))}
    </div>
  );
}

export default function AdmissionFormPage() {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    // Personal
    name: "",
    fatherName: "",
    guardianName: "",
    occupation: "",
    aadhar: "",
    placeOfBirth: "",
    mobile: "",
    whatsapp: "",
    dob: "",
    address: "",
    city: "",
    district: "",
    state: "",
    pincode: "",
    // Education
    prevSchool: "",
    prevClass: "",
    prevPercent: "",
    books: "",
    reasonLeaving: "",
    classToEnroll: "",
    enrolledBefore: "",
    whatWasTheAnswer: "",
    orphan: "",
    // Other
    readUrdu: "",
    writeUrdu: "",
    readQuran: "",
    relatives: "",
    names: "",
    // Uploads
    uploadAadhar: null,
    uploadMarks: null,
    uploadPhoto: null,
    uploadOther: null,
    // Terms
    terms: false,
    // Registration
    registrationId: "",
  });

  const handleFile = (e, key) =>
    setForm((f) => ({ ...f, [key]: e.target.files[0] }));
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setForm((f) => ({
      ...f,
      registrationId: `JAMIA${Math.floor(100000 + Math.random() * 900000)}`,
    }));
    setStep(step + 1);
  };

  return (
    <Layout>
      <div
        style={{ background: "#f9fafb", minHeight: "100vh", padding: "2rem 0" }}
      >
        <form
          style={{
            maxWidth: 900,
            margin: "auto",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            padding: "2rem 1.5rem 1rem 1.5rem",
            display: "flex",
            flexDirection: "column",
          }}
          onSubmit={handleSubmit}
        >
          {/* Step 1: Gallery/Intro */}
          {step === 0 && (
            <>
              {/* <p style={{ textAlign: "center", color: "#444" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p> */}
              <div
                style={{
                  direction: "rtl",
                  textAlign: "right",
                  color: "#444",
                  fontSize: "1rem",
                  lineHeight: "1.8",
                  fontFamily: "'CustomFont', serif",
                }}
              >
                <p style={{ fontFamily: ["CustomFont"] }}>
                  جامعہ کا شعبہ داخلہ طلبہ کے داخلے کے عمل کو منظم کرنے کا ذمہ
                  دار ہے۔ یہ شعبہ ہر تعلیمی سال کے آغاز سے قبل داخلہ کی پالیسی،
                  اہلیت کے معیار، داخلہ فارم کی تقسیم، داخلہ امتحانات، انٹرویوز،
                  اور منتخب طلبہ کی فہرست کی اشاعت جیسے تمام اہم مراحل کی نگرانی
                  کرتا ہے۔
                </p>
                <p style={{ fontFamily: ["CustomFont"] }}>
                  داخلہ کے خواہشمند طلبہ کو مشورہ دیا جاتا ہے کہ وہ جامعہ کی
                  جانب سے جاری کردہ داخلہ شیڈول اور ہدایات کو بغور ملاحظہ کریں
                  تاکہ کسی بھی مرحلے پر دقت نہ ہو۔ مزید معلومات کے لیے، طلبہ
                  شعبہ داخلہ سے براہ راست رابطہ کر سکتے ہیں۔
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 18,
                  alignItems: "center",
                  margin: "2rem 0",
                }}
              >
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    style={{
                      width: 120,
                      height: 120,
                      border: "3px solid #f59e42",
                      borderRadius: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ImageIcon />
                  </div>
                ))}
              </div>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 18,
                }}
              >
                <input
                  type="checkbox"
                  name="terms"
                  checked={form.terms}
                  onChange={handleChange}
                />
                Accept
              </label>
              <button
                type="button"
                disabled={!form.terms}
                style={{
                  background: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "10px 32px",
                  fontWeight: 600,
                  fontSize: "1rem",
                  cursor: form.terms ? "pointer" : "not-allowed",
                }}
                onClick={() => setStep(1)}
              >
                apply
              </button>
            </>
          )}

          {/*           
          {step === 1 && (
  <>
    <h3 style={{
      margin: "0 0 1.5rem 0",
      fontWeight: 700,
      fontSize: 22,
      color: "#000",
      borderBottom: "2px solid #000",
      paddingBottom: "0.5rem"
    }}>
      PERSONAL DETAILS
    </h3>

    <div style={{
      maxWidth: "1000px",
      margin: "auto",
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "1.5rem 2rem",
      backgroundColor: "#f9f9f9",
      padding: "2rem",
      borderRadius: "10px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)"
    }}>
      {[
        { name: "name", label: "Name" },
        { name: "fatherName", label: "Father Name" },
        { name: "guardianName", label: "Guardian Name" },
        { name: "occupation", label: "Occupation" },
        { name: "aadhar", label: "Aadhar Number" },
        { name: "placeOfBirth", label: "Place of Birth" },
        { name: "mobile", label: "Mobile Number" },
        { name: "whatsapp", label: "WhatsApp Number" },
        { name: "dob", label: "Date of Birth", type: "date" },
        { name: "address", label: "Permanent Address" },
        { name: "city", label: "City" },
        { name: "district", label: "District" },
        { name: "state", label: "State" },
        { name: "pincode", label: "Pin Code" },
      ].map((field, i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: 6, fontWeight: 500, color: "#000", fontSize: 14 }}>
            {field.label}
          </label>
          <input
            type={field.type || "text"}
            name={field.name}
            value={form[field.name]}
            onChange={handleChange}
            style={{
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "16px",
              color: "#000",
              backgroundColor: "#fff",
              boxSizing: "border-box"
            }}
          />
        </div>
      ))}
    </div>

    <div style={{
      display: "flex",
      justifyContent: "flex-end",
      gap: 12,
      marginTop: "2rem"
    }}>
      <button
        type="button"
        disabled
        style={{
          opacity: 0.5,
          background: "#eee",
          border: "none",
          borderRadius: 6,
          padding: "10px 28px",
          fontWeight: 600,
          cursor: "not-allowed"
        }}
      >
        Prev
      </button>

      <button
        type="button"
        onClick={() => setStep(2)}
        style={{
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "10px 28px",
          fontWeight: 600,
          cursor: "pointer"
        }}
      >
        Next
      </button>
    </div>

    <PageIndicators step={step} />
  </>
)} */}
          {step === 1 && (
            <>
              <h3
                style={{
                  margin: "0 0 1.5rem 0",
                  fontWeight: 700,
                  fontSize: 22,
                  color: "#000",
                  borderBottom: "2px solid #000",
                  paddingBottom: "0.5rem",
                }}
              >
                PERSONAL DETAILS / ذاتی معلومات
              </h3>

              <div
                style={{
                  maxWidth: "1000px",
                  margin: "auto",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1.5rem 2rem",
                  backgroundColor: "#f9f9f9",
                  padding: "2rem",
                  borderRadius: "10px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
              >
                {[
                  { name: "name", label: "Name / نام" },
                  { name: "fatherName", label: "Father Name / والد کا نام" },
                  {
                    name: "guardianName",
                    label: "Guardian Name / سرپرست کا نام",
                  },
                  { name: "occupation", label: "Occupation / پیشہ" },
                  { name: "aadhar", label: "Aadhar Number / آدھار نمبر" },
                  {
                    name: "placeOfBirth",
                    label: "Place of Birth / جائے پیدائش",
                  },
                  { name: "mobile", label: "Mobile Number / موبائل نمبر" },
                  {
                    name: "whatsapp",
                    label: "WhatsApp Number / واٹس ایپ نمبر",
                  },
                  {
                    name: "dob",
                    label: "Date of Birth / تاریخ پیدائش",
                    type: "date",
                  },
                  { name: "address", label: "Permanent Address / مستقل پتہ" },
                  { name: "city", label: "City / شہر" },
                  { name: "district", label: "District / ضلع" },
                  { name: "state", label: "State / ریاست" },
                  { name: "pincode", label: "Pin Code / پن کوڈ" },
                ].map((field, i) => (
                  <div
                    key={i}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label
                      style={{
                        marginBottom: 6,
                        fontWeight: 500,
                        color: "#000",
                        fontSize: 14,
                      }}
                    >
                      {field.label}
                    </label>
                    <input
                      type={field.type || "text"}
                      name={field.name}
                      value={form[field.name]}
                      onChange={handleChange}
                      style={{
                        padding: "10px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                        color: "#000",
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: "2rem",
                }}
              >
                <button
                  type="button"
                  disabled
                  style={{
                    opacity: 0.5,
                    background: "#eee",
                    border: "none",
                    borderRadius: 6,
                    padding: "10px 28px",
                    fontWeight: 600,
                    cursor: "not-allowed",
                  }}
                >
                  Prev / پچھلا
                </button>

                <button
                  type="button"
                  onClick={() => setStep(2)}
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "10px 28px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Next / اگلا
                </button>
              </div>

              <PageIndicators step={step} />
            </>
          )}

          {/* {step === 2 && (
  <>
    <h3 style={{
      margin: "0 0 1.5rem 0",
      fontWeight: 700,
      fontSize: 22,
      color: "#000",
      borderBottom: "2px solid #000",
      paddingBottom: "0.5rem"
    }}>
      EDUCATION DETAILS
    </h3>

    <div style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "1.5rem 2rem",
      backgroundColor: "#f9f9f9",
      padding: "2rem",
      borderRadius: "10px",
      boxShadow: "0 0 10px rgba(0,0,0,0.1)"
    }}>
      {[
        { name: "prevSchool", label: "Previous School / Madrasa Name" },
        { name: "prevClass", label: "Previous Class / Jamat Name" },
        { name: "prevPercent", label: "Previous Class Percentage" },
        { name: "books", label: "Books Studied in Previous Class" },
      ].map((field, i) => (
        <div key={i} style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>{field.label}</label>
          <input
            type="text"
            name={field.name}
            value={form[field.name]}
            onChange={handleChange}
            style={{
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "16px",
              color: "#000",
              backgroundColor: "#fff",
              boxSizing: "border-box"
            }}
          />
        </div>
      ))}

      <div style={{ gridColumn: "1 / -1", display: "flex", flexDirection: "column" }}>
        <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>
          Reason for leaving previous school
        </label>
        <input
          type="text"
          name="reasonLeaving"
          value={form.reasonLeaving}
          onChange={handleChange}
          style={{
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
            color: "#000",
            backgroundColor: "#fff",
            boxSizing: "border-box"
          }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>
          Class To Enroll
        </label>
        <select
          name="classToEnroll"
          value={form.classToEnroll}
          onChange={handleChange}
          style={{
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
            backgroundColor: "#fff",
            color: "#000"
          }}
        >
          <option value="">Class Name</option>
          <option value="Nursery">Nursery</option>
          <option value="KG">KG</option>
          <option value="1st">1st</option>
          <option value="2nd">2nd</option>
        </select>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>
          Enrolled In Jamia Before
        </label>
        <div style={{ display: "flex", gap: 20 }}>
          <label><input type="radio" name="enrolledBefore" value="Yes" checked={form.enrolledBefore === "Yes"} onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="enrolledBefore" value="No" checked={form.enrolledBefore === "No"} onChange={handleChange} /> No</label>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>
          What Was The Answer
        </label>
        <input
          type="text"
          name="whatWasTheAnswer"
          value={form.whatWasTheAnswer}
          onChange={handleChange}
          style={{
            padding: "10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
            color: "#000",
            backgroundColor: "#fff"
          }}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <label style={{ marginBottom: 6, fontWeight: 500, color: "#000" }}>
          Are You An Orphan
        </label>
        <div style={{ display: "flex", gap: 20 }}>
          <label><input type="radio" name="orphan" value="Yes" checked={form.orphan === "Yes"} onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="orphan" value="No" checked={form.orphan === "No"} onChange={handleChange} /> No</label>
        </div>
      </div>
    </div>

    <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: "2rem" }}>
      <button
        type="button"
        onClick={() => setStep(1)}
        style={{
          background: "#eee",
          border: "none",
          borderRadius: 6,
          padding: "10px 28px",
          fontWeight: 600,
          color: "#000"
        }}
      >
        Prev
      </button>

      <button
        type="button"
        onClick={() => setStep(3)}
        style={{
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "10px 28px",
          fontWeight: 600,
          cursor: "pointer"
        }}
      >
        Next
      </button>
    </div>

    <PageIndicators step={step} />
  </>
)} */}
          {step === 2 && (
            <>
              <h3
                style={{
                  margin: "0 0 1.5rem 0",
                  fontWeight: 700,
                  fontSize: 22,
                  color: "#000",
                  borderBottom: "2px solid #000",
                  paddingBottom: "0.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  direction: "ltr",
                }}
              >
                <span>EDUCATION DETAILS</span>
                <span
                  style={{
                    direction: "rtl",
                    fontWeight: 700,
                    fontSize: 22,
                    color: "#000",
                  }}
                >
                  تعلیمی تفصیلات
                </span>
              </h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1.5rem 2rem",
                  backgroundColor: "#f9f9f9",
                  padding: "2rem",
                  borderRadius: "10px",
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                }}
              >
                {[
                  {
                    name: "prevSchool",
                    label: "Previous School / Madrasa Name",
                    urdu: "پچھلا مدرسہ / اسکول کا نام",
                  },
                  {
                    name: "prevClass",
                    label: "Previous Class / Jamat Name",
                    urdu: "پچھلی جماعت / جماعت کا نام",
                  },
                  {
                    name: "prevPercent",
                    label: "Previous Class Percentage",
                    urdu: "پچھلی جماعت میں فیصد",
                  },
                  {
                    name: "books",
                    label: "Books Studied in Previous Class",
                    urdu: "پچھلی جماعت میں پڑھی گئی کتابیں",
                  },
                ].map((field, i) => (
                  <div
                    key={i}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label
                      style={{
                        marginBottom: 6,
                        fontWeight: 500,
                        color: "#000",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{field.label}</span>
                      <span style={{ direction: "rtl", fontWeight: 500 }}>
                        {field.urdu}
                      </span>
                    </label>
                    <input
                      type="text"
                      name={field.name}
                      value={form[field.name]}
                      onChange={handleChange}
                      style={{
                        padding: "10px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        fontSize: "16px",
                        color: "#000",
                        backgroundColor: "#fff",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                ))}

                <div
                  style={{
                    gridColumn: "1 / -1",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <label
                    style={{
                      marginBottom: 6,
                      fontWeight: 500,
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Reason for leaving previous school</span>
                    <span style={{ direction: "rtl", fontWeight: 500 }}>
                      پچھلے مدرسے کو چھوڑنے کی وجہ
                    </span>
                  </label>
                  <input
                    type="text"
                    name="reasonLeaving"
                    value={form.reasonLeaving}
                    onChange={handleChange}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px",
                      color: "#000",
                      backgroundColor: "#fff",
                      boxSizing: "border-box",
                    }}
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      marginBottom: 6,
                      fontWeight: 500,
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Class To Enroll</span>
                    <span style={{ direction: "rtl", fontWeight: 500 }}>
                      داخلہ لینے والی جماعت
                    </span>
                  </label>
                  <select
                    name="classToEnroll"
                    value={form.classToEnroll}
                    onChange={handleChange}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px",
                      backgroundColor: "#fff",
                      color: "#000",
                    }}
                  >
                    <option value="">
                      {/* bilingual placeholder */}
                      Class Name / جماعت کا نام
                    </option>
                    <option value="Nursery">Nursery / نرسری</option>
                    <option value="KG">KG / کے جی</option>
                    <option value="1st">1st / پہلی</option>
                    <option value="2nd">2nd / دوسری</option>
                  </select>
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      marginBottom: 6,
                      fontWeight: 500,
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Enrolled In Jamia Before</span>
                    <span style={{ direction: "rtl", fontWeight: 500 }}>
                      کیا آپ پہلے جامعہ میں داخلہ لے چکے ہیں؟
                    </span>
                  </label>
                  <div style={{ display: "flex", gap: 20 }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        direction: "ltr",
                      }}
                    >
                      <input
                        type="radio"
                        name="enrolledBefore"
                        value="Yes"
                        checked={form.enrolledBefore === "Yes"}
                        onChange={handleChange}
                      />
                      <span>Yes / ہاں</span>
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        direction: "ltr",
                      }}
                    >
                      <input
                        type="radio"
                        name="enrolledBefore"
                        value="No"
                        checked={form.enrolledBefore === "No"}
                        onChange={handleChange}
                      />
                      <span>No / نہیں</span>
                    </label>
                  </div>
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      marginBottom: 6,
                      fontWeight: 500,
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>What Was The Answer</span>
                    <span style={{ direction: "rtl", fontWeight: 500 }}>
                      جواب کیا تھا
                    </span>
                  </label>
                  <input
                    type="text"
                    name="whatWasTheAnswer"
                    value={form.whatWasTheAnswer}
                    onChange={handleChange}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "16px",
                      color: "#000",
                      backgroundColor: "#fff",
                    }}
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      marginBottom: 6,
                      fontWeight: 500,
                      color: "#000",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>Are You An Orphan</span>
                    <span style={{ direction: "rtl", fontWeight: 500 }}>
                      کیا آپ یتیم ہیں؟
                    </span>
                  </label>
                  <div style={{ display: "flex", gap: 20 }}>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        direction: "ltr",
                      }}
                    >
                      <input
                        type="radio"
                        name="orphan"
                        value="Yes"
                        checked={form.orphan === "Yes"}
                        onChange={handleChange}
                      />
                      <span>Yes / ہاں</span>
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.25rem",
                        direction: "ltr",
                      }}
                    >
                      <input
                        type="radio"
                        name="orphan"
                        value="No"
                        checked={form.orphan === "No"}
                        onChange={handleChange}
                      />
                      <span>No / نہیں</span>
                    </label>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: "2rem",
                }}
              >
                <button
                  type="button"
                  onClick={() => setStep(1)}
                  style={{
                    background: "#eee",
                    border: "none",
                    borderRadius: 6,
                    padding: "10px 28px",
                    fontWeight: 600,
                    color: "#000",
                  }}
                >
                  Prev / پچھلا
                </button>

                <button
                  type="button"
                  onClick={() => setStep(3)}
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "10px 28px",
                    fontWeight: 600,
                    cursor: "pointer",
                  }}
                >
                  Next / اگلا
                </button>
              </div>

              <PageIndicators step={step} />
            </>
          )}

          {step === 3 && (
            <>
              {/* Section Title */}
              <h3
                style={{
                  margin: "0 0 0.6rem 0",
                  fontWeight: 700,
                  fontSize: 24,
                  color: "#000",
                  borderBottom: "2px solid #000",
                  paddingBottom: 8,
                }}
              >
                OTHER DETAILS
              </h3>

              {/* Other Details: Two-column grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "32px 32px",
                  margin: "32px 0",
                }}
              >
                {/* Can You Read Urdu */}
                <div>
                  <div style={{ color: "#000", marginBottom: 8 }}>
                    Can You Read Urdu:
                  </div>
                  <label style={{ color: "#000", marginRight: 18 }}>
                    <input
                      type="radio"
                      name="readUrdu"
                      value="Yes"
                      checked={form.readUrdu === "Yes"}
                      onChange={handleChange}
                    />{" "}
                    Yes
                  </label>
                  <label style={{ color: "#000" }}>
                    <input
                      type="radio"
                      name="readUrdu"
                      value="No"
                      checked={form.readUrdu === "No"}
                      onChange={handleChange}
                    />{" "}
                    No
                  </label>
                </div>
                {/* Can You Write Urdu */}
                <div>
                  <div style={{ color: "#000", marginBottom: 8 }}>
                    Can You Write Urdu:
                  </div>
                  <label style={{ color: "#000", marginRight: 18 }}>
                    <input
                      type="radio"
                      name="writeUrdu"
                      value="Yes"
                      checked={form.writeUrdu === "Yes"}
                      onChange={handleChange}
                    />{" "}
                    Yes
                  </label>
                  <label style={{ color: "#000" }}>
                    <input
                      type="radio"
                      name="writeUrdu"
                      value="No"
                      checked={form.writeUrdu === "No"}
                      onChange={handleChange}
                    />{" "}
                    No
                  </label>
                </div>
                {/* Can You Read Quran */}
                <div>
                  <div style={{ color: "#000", marginBottom: 8 }}>
                    Can You Read Quran:
                  </div>
                  <label style={{ color: "#000", marginRight: 18 }}>
                    <input
                      type="radio"
                      name="readQuran"
                      value="Yes"
                      checked={form.readQuran === "Yes"}
                      onChange={handleChange}
                    />{" "}
                    Yes
                  </label>
                  <label style={{ color: "#000" }}>
                    <input
                      type="radio"
                      name="readQuran"
                      value="No"
                      checked={form.readQuran === "No"}
                      onChange={handleChange}
                    />{" "}
                    No
                  </label>
                </div>
                {/* Relatives in Jamia */}
                <input
                  name="relatives"
                  value={form.relatives}
                  onChange={handleChange}
                  placeholder="Relatives in Jamia"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: 4,
                    border: "1.5px solid #e5e7eb",
                    color: "#000",
                    background: "#f8fafc",
                    fontSize: 18,
                    fontFamily: "inherit",
                  }}
                />
                {/* Names (full width) */}
                <input
                  name="names"
                  value={form.names}
                  onChange={handleChange}
                  placeholder="Names"
                  style={{
                    gridColumn: "1 / span 2",
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: 4,
                    border: "1.5px solid #e5e7eb",
                    color: "#000",
                    background: "#f8fafc",
                    fontSize: 18,
                    fontFamily: "inherit",
                  }}
                />
              </div>

              {/* Uploads Section */}
              <h3
                style={{
                  margin: "1.2rem 0 0.6rem 0",
                  fontWeight: 700,
                  fontSize: 24,
                  color: "#000",
                  borderBottom: "2px solid #000",
                  paddingBottom: 8,
                }}
              >
                UPLOADS
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "24px 24px",
                  margin: "32px 0",
                }}
              >
                {[
                  {
                    label: "Upload aadhar",
                    key: "uploadAadhar",
                    accept: ".pdf,.jpg,.png",
                  },
                  {
                    label: "Upload Previous Marks Memp",
                    key: "uploadMarks",
                    accept: ".pdf,.jpg,.png",
                  },
                  {
                    label: "Upload Photo",
                    key: "uploadPhoto",
                    accept: ".jpg,.png",
                  },
                  {
                    label: "Upload other docs",
                    key: "uploadOther",
                    accept: ".pdf,.jpg,.png",
                  },
                ].map((field) => (
                  <div
                    key={field.key}
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <label
                      style={{ flex: 1, color: "#000", position: "relative" }}
                    >
                      <input
                        type="file"
                        accept={field.accept}
                        style={{ display: "none" }}
                        id={field.key}
                        onChange={(e) => handleFile(e, field.key)}
                      />
                      <span
                        style={{
                          display: "block",
                          width: "100%",
                          padding: "12px 16px",
                          borderRadius: 4,
                          border: "1.5px solid #e5e7eb",
                          background: "#f8fafc",
                          color: "#000",
                          fontSize: 18,
                          fontFamily: "inherit",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          document.getElementById(field.key).click()
                        }
                      >
                        {field.label}
                      </span>
                    </label>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 38,
                        height: 38,
                        border: "2px solid #000",
                        borderRadius: 6,
                        background: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={() => document.getElementById(field.key).click()}
                    >
                      {/* Upload icon (arrow up) */}
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#000"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M10 15V5" />
                        <polyline points="5 10 10 5 15 10" />
                      </svg>
                    </span>
                  </div>
                ))}
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 12,
                  marginTop: 32,
                }}
              >
                <button
                  type="button"
                  onClick={() => setStep(2)}
                  style={{
                    background: "#eee",
                    border: "none",
                    borderRadius: 6,
                    padding: "12px 36px",
                    fontWeight: 600,
                    fontSize: 18,
                    color: "#888",
                  }}
                >
                  Prev
                </button>
                <button
                  type="submit"
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "12px 36px",
                    fontWeight: 600,
                    fontSize: 18,
                  }}
                >
                  submit
                </button>
              </div>
              <PageIndicators step={step} />
            </>
          )}

          {step === 4 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 500,
                margin: "3rem 0",
              }}
            >
              <div
                style={{
                  width: "100%",
                  textAlign: "left",
                  fontWeight: 800,
                  fontSize: 28,
                  color: "#000",
                  marginBottom: 24,
                  borderBottom: "2px solid #000",
                  paddingBottom: 8,
                  letterSpacing: 0.5,
                }}
              >
                Submit
              </div>
              <h2
                style={{
                  fontWeight: 800,
                  fontSize: 32,
                  color: "#000",
                  marginBottom: 16,
                  letterSpacing: 0.5,
                }}
              >
                Registration Successful!
              </h2>
              <p
                style={{
                  color: "#000",
                  fontSize: 20,
                  marginBottom: 36,
                  maxWidth: 600,
                }}
              >
                Thank you for your application. Your registration has been
                received.
                <br />
                Please save your Registration ID for future reference.
              </p>
              <h3
                style={{
                  margin: "2rem 0 1rem 0",
                  fontWeight: 700,
                  fontSize: 22,
                  color: "#000",
                  letterSpacing: 1,
                }}
              >
                REGISTRATION ID
              </h3>
              <div
                style={{
                  display: "inline-block",
                  background: "#fff",
                  border: "2.5px dashed #2563eb",
                  borderRadius: 10,
                  padding: "1.2rem 3.5rem",
                  fontSize: "1.5rem",
                  fontWeight: 800,
                  letterSpacing: 2,
                  color: "#000",
                  marginBottom: 32,
                }}
              >
                {form.registrationId}
              </div>
              <button
                type="button"
                style={{
                  background: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "16px 48px",
                  fontWeight: 700,
                  fontSize: "1.2rem",
                  margin: "2rem 0 0 0",
                  boxShadow: "0 2px 8px rgba(37,99,235,0.15)",
                  cursor: "pointer",
                }}
                onClick={() => window.print()}
              >
                PRINT
              </button>
              <div style={{ marginTop: 40 }}>
                <PageIndicators step={3} />
              </div>
            </div>
          )}
        </form>
      </div>
    </Layout>
  );
}
